export default __webpack_public_path__ + "static/media/customCloseIcon.f6150767.svg";